<template>
    <div class="container">
        <div @click.stop="closeConfirmPopup" class="background_mask"></div>
        <div style="width: calc(100% - 24px)" :style="{ transform: popupTransform }" class="frame_box">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CommonConfirmFrame',
    props: {
        isShowConfirmPopup: {
            type: Boolean,
            default: false
        },
        closeConfirmPopup: {
            type: Function,
            default: () => { }
        },
        containerWidth: {
            type: String,
            default: '100%'
        },
        popupTransform: {
            type: String,
            default: 'translateY(0)'
        }
    },
}
</script>

<style scoped>
.container {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
}

.background_mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
}

.frame_box {
    display: inline-block;
    background-color: #fff;
    border-radius: 24px;
    padding: 16px;
    z-index: 200;
    transition: 0.2s all;
}
</style>